import styles from './EditScenarioNavBar.module.css';
import { bookIcon, charactersIcon, messagesIcon, globeIcon } from '../../assets/icons';

interface EditScenarioNavBarProps {
  activeSection: 'details' | 'characters' | 'messages' | 'world';
  onNavigate: (section: 'details' | 'characters' | 'messages' | 'world') => void;
}

function EditScenarioNavBar({ activeSection, onNavigate }: EditScenarioNavBarProps): JSX.Element {
  return (
    <nav className={styles.navbar}>
      <button 
        className={`${styles.navButton} ${activeSection === 'details' ? styles.active : ''}`}
        onClick={() => onNavigate('details')}
      >
        <img src={bookIcon} alt="Details" className={styles.navIcon} />
        {activeSection === 'details' && <span>Details</span>}
      </button>
      
      <button 
        className={`${styles.navButton} ${activeSection === 'characters' ? styles.active : ''}`}
        onClick={() => onNavigate('characters')}
      >
        <img src={charactersIcon} alt="Characters" className={styles.navIcon} />
        {activeSection === 'characters' && <span>Characters</span>}
      </button>
      
      <button 
        className={`${styles.navButton} ${activeSection === 'messages' ? styles.active : ''}`}
        onClick={() => onNavigate('messages')}
      >
        <img src={messagesIcon} alt="Messages" className={styles.navIcon} />
        {activeSection === 'messages' && <span>Messages</span>}
      </button>
      
      <button 
        className={`${styles.navButton} ${activeSection === 'world' ? styles.active : ''}`}
        onClick={() => onNavigate('world')}
      >
        <img src={globeIcon} alt="World" className={styles.navIcon} />
        {activeSection === 'world' && <span>World</span>}
      </button>
    </nav>
  );
}

export default EditScenarioNavBar; 